// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"fca7b059","453":"175749ec","827":"a8820ce5"}[chunkId] + ".chunk.js";
};